// Pathway stage vocabulary shared by the editor, the board, the list and the
// pedigree sidebar (TGCLOUD-1901). Labels are English; render them through
// t(). The server's list is backend/services/pathways/stageTypes.js.

export const STAGE_TYPE_LABELS = Object.freeze({
  PATIENT_FORM: 'Patient Form',
  CLINICIAN_TASK: 'Clinician Task',
  TEST: 'Test',
  APPOINTMENT: 'Appointment',
  CONSENT: 'Consent',
  FHQ: 'Family History Questionnaire',
  CONTACT: 'Contact',
  COMPLETE: 'Complete'
});

/** What an instance's questionnaire has reached: not_sent | sent | received | applied. */
export const fhqStatusOf = (instance) => {
  const f = instance?.fhq || {};
  if (f.appliedAt) return 'applied';
  if (f.receivedAt) return 'received';
  if (f.sentAt) return 'sent';
  return 'not_sent';
};

export const FORM_STAGE_TYPES = Object.freeze(['PATIENT_FORM', 'CONSENT']);

/** The English label of a stage type; an unknown type reads as its words. */
export const stageTypeLabel = (type) =>
  STAGE_TYPE_LABELS[type] || String(type || '').replace(/_/g, ' ');

// What a stage key that matches no stage of the template reads as. A patient
// can only be on such a key when a template edit predates the server's
// refusal to remove an occupied stage.
export const STAGE_GONE = 'Stage no longer on this pathway';

/**
 * A new stage's key: opaque, minted once, never derived from the name, so a
 * rename never moves the patients on it. The server mints one the same way
 * for a stage that arrives without one.
 */
export function newStageKey() {
  const hex =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID().replace(/-/g, '')
      : Array.from({ length: 12 }, () =>
          Math.floor(Math.random() * 16).toString(16)
        ).join('');
  return `s_${hex.slice(0, 12)}`;
}
